
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const Blog = lazy(() => import('../pages/blog/page'));
const BlogArticle = lazy(() => import('../pages/blog/article/page'));
const Events = lazy(() => import('../pages/events/page'));
const Artists = lazy(() => import('../pages/artists/page'));
const Media = lazy(() => import('../pages/media/page'));
const Partners = lazy(() => import('../pages/partners/page'));
const Admin = lazy(() => import('../pages/admin/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/blog',
    element: <Blog />,
  },
  {
    path: '/blog/article',
    element: <BlogArticle />,
  },
  {
    path: '/artists',
    element: <Artists />,
  },
  {
    path: '/partners',
    element: <Partners />,
  },
  {
    path: '/events',
    element: <Events />,
  },
  {
    path: '/media',
    element: <Media />,
  },
  {
    path: '/admin',
    element: <Admin />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
